import * as THREE from 'three'
import Experience from "../Experience";
import Casino from './casino/casino';


export default class World {

    constructor() {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.ressources = this.experience.ressources
        this.time = this.experience.time



        this.ressources.on('ready', () => {
            this.casino = new Casino()

        })






        this.update()

    }



    resize() {
        this.casino?.resize()

    }

    update() {
        this.casino?.update()

    }

}